/* eslint-disable @typescript-eslint/no-unused-vars */
'use client'
import React, { useMemo } from 'react'
import { S3_PREFIX } from '@/shared/constants'
import TeamPlaceholder from '@/assets/images/placeholder/team.png'
import getStatus from '@/shared/hooks/useStatus'
import { convertDate, dateCheck, replaceStringToShort } from '@/shared/utils'
import MyImage from '@/shared/components/myImage'
import CustomLink from '../../customLink'
import { ENUM_CRICKET_MATCH_PAGES } from '@/shared/enum'

const scoreSplit = (score: any) => {
  if (score?.includes('&')) {
    let newScoreString = ''
    score.split('&').forEach((ele: any, i: number) => {
      if (i === 0 && ele) {
        const [score] = ele.split(' (')
        newScoreString += score + ' &'
      } else if (ele) {
        newScoreString += ele
      }
    })
    score = newScoreString
  }
  const scoreSplittedData = score?.split(' ')
  if (scoreSplittedData && scoreSplittedData?.length > 0) {
    return (
      <span className="text-textOffWhite text-xs md:text-lg">
        {scoreSplittedData?.map((ele: string, i: number) => {
          if (ele.match(/\(|\)/) || ele.includes('&')) {
            return (
              <span key={ele + i} className="font-normal text-xs md:text-base text-textDselected">
                {ele + ' '}
              </span>
            )
          } else {
            return <b key={ele + i}>{ele + ' '}</b>
          }
        })}
      </span>
    )
  }
}

type SeriesScoreCardType = {
  className?: string
  defaultBordered?: boolean
  hideBtns?: boolean
  card: {
    _id?: string
    oMatchSeos?: any
    dStartDate: number | Date
    sStatusNote?: string | null
    iBattingTeamId?: string | null
    iWinnerId?: string | null
    nLatestInningNumber: number
    oVenue?: { sLocation?: string }
    oSeo?: { sSlug?: string | null }
    sSubtitle?: string
    oTeamScoreA: {
      sScoresFull?: string | null
      oTeam?: {
        _id?: string
        sTitle?: string
        sAbbr?: string
        oImg?: { sUrl?: string }
      }
    } | null
    oTeamScoreB: {
      sScoresFull?: string | null
      oTeam?: {
        _id?: string
        sTitle?: string
        sAbbr?: string
        oImg?: { sUrl?: string }
      }
    } | null
  }
}

export default function SeriesScoreCard({ card, hideBtns = false }: SeriesScoreCardType) {
  const { sStatus, sStatusStr, sLiveGameStatus } = getStatus(card as any)
  const rewriteURLs = useMemo(() => {
    const seriesUrls: Record<string, string> = {}
    card?.oMatchSeos?.oSeo?.forEach((e: { eSubType: string | undefined; sSlug: string }): void => {
      seriesUrls[ENUM_CRICKET_MATCH_PAGES[e?.eSubType || 'i']] = e?.sSlug?.replace(
        'cricket/live-score',
        'live-cricket-score'
      )
    })
    return seriesUrls
  }, [sStatusStr])

  const TeamA = useMemo(
    () => (
      <div className={`font-medium flex items-center`}>
        <div className="md:w-10 md:h-10 w-6 h-6">
          <MyImage
            src={
              card?.oTeamScoreA?.oTeam?.oImg?.sUrl
                ? `${S3_PREFIX}${card?.oTeamScoreA?.oTeam?.oImg?.sUrl}`
                : TeamPlaceholder
            }
            placeholderImage={TeamPlaceholder}
            loadOnScroll
            className="aspect-square rounded-full"
            alt={card?.oTeamScoreA?.oTeam?.sAbbr}
            width={40}
            height={40}
            sizes="(max-width: 767px) 24px, (max-width: 991px) 24px, (max-width: 1190px) 200px, 24px"
          />
        </div>
      </div>
    ),
    [card, sStatusStr]
  )

  const TeamB = useMemo(
    () => (
      <div className={`font-medium flex items-center`}>
        <div className="md:w-10 md:h-10 w-6 h-6">
          <MyImage
            src={
              card?.oTeamScoreB?.oTeam?.oImg?.sUrl
                ? `${S3_PREFIX}${card?.oTeamScoreB?.oTeam?.oImg?.sUrl}`
                : TeamPlaceholder
            }
            placeholderImage={TeamPlaceholder}
            loadOnScroll
            className="aspect-square rounded-full"
            alt={card?.oTeamScoreB?.oTeam?.sAbbr}
            width={40}
            height={40}
            sizes="(max-width: 767px) 24px, (max-width: 991px) 24px, (max-width: 1190px) 200px, 24px"
          />
        </div>
      </div>
    ),
    [card, sStatusStr]
  )

  const scoreA = useMemo(
    () => (
      <>
        {card?.nLatestInningNumber === 1 &&
          (card?.oTeamScoreA?.sScoresFull ? (
            <span>{scoreSplit(card?.oTeamScoreA?.sScoresFull)}</span>
          ) : (
            <span className="text-t-light">{'YetToBat'}</span>
          ))}
        {card?.nLatestInningNumber > 1 &&
          (card?.oTeamScoreA?.sScoresFull?.includes('*') ? (
            <span>{scoreSplit(card?.oTeamScoreA?.sScoresFull)}</span>
          ) : (
            <span
              className={
                sStatusStr === 'completed' && card?.oTeamScoreA?.oTeam?._id === card?.iWinnerId
                  ? 'text-primary-500'
                  : 'text-textOffWhite'
              }
            >
              {scoreSplit(card?.oTeamScoreA?.sScoresFull)}
            </span>
          ))}
      </>
    ),
    [card, sStatusStr]
  )

  const TeamAscore = useMemo(
    () => (
      <div className="text-left">
        {sStatusStr !== 'scheduled' && sStatusStr !== 'cancelled' ? (
          <div className="text-sm md:text-base font-bold text-textOffWhite uppercase">
            {card?.oTeamScoreA?.oTeam?.sAbbr}
          </div>
        ) : (
          <>
            <span className="text-sm md:text-base font-bold hidden md:block text-textOffWhite ">
              {card?.oTeamScoreA?.oTeam?.sTitle}
            </span>
            <div className="text-sm md:text-base font-bold block md:hidden text-textOffWhite uppercase">
              {card?.oTeamScoreA?.oTeam?.sAbbr}
            </div>
          </>
        )}
        <p className="font-normal text-xs md:text-lg hidden md:flex items-center mt-0.5">
          {scoreA}
        </p>
      </div>
    ),
    [card, sStatusStr]
  )

  const scoreB = useMemo(
    () => (
      <>
        {card?.nLatestInningNumber === 1 &&
          (card?.oTeamScoreB?.sScoresFull ? (
            <span>{scoreSplit(card?.oTeamScoreB?.sScoresFull)}</span>
          ) : (
            <span className="text-t-light">Yet To Bat</span>
          ))}
        {card?.nLatestInningNumber > 1 &&
          (card?.oTeamScoreB?.sScoresFull?.includes('*') ? (
            <span>{scoreSplit(card?.oTeamScoreB?.sScoresFull)}</span>
          ) : (
            <span
              className={
                sStatusStr === 'completed' && card?.oTeamScoreB?.oTeam?._id === card?.iWinnerId
                  ? 'text-primary-500'
                  : 'text-t-textOffWhite'
              }
            >
              {scoreSplit(card?.oTeamScoreB?.sScoresFull)}
            </span>
          ))}
      </>
    ),
    [card, sStatusStr]
  )

  const TeamBscore = useMemo(
    () => (
      <div className="text-right">
        {sStatusStr !== 'scheduled' && sStatusStr !== 'cancelled' ? (
          <div className="text-sm md:text-base font-bold text-textOffWhite uppercase">
            {card?.oTeamScoreB?.oTeam?.sAbbr}
          </div>
        ) : (
          <>
            <span className="text-sm md:text-base font-bold md:block hidden text-textOffWhite ">
              {card?.oTeamScoreB?.oTeam?.sTitle}
            </span>
            <div className="text-sm md:text-base font-bold block md:hidden text-textOffWhite uppercase">
              {card?.oTeamScoreB?.oTeam?.sAbbr}
            </div>
          </>
        )}
        <p className="font-normal text-base hidden md:flex items-center mt-0.5">{scoreB}</p>
      </div>
    ),
    [card, sStatusStr]
  )

  const statusColor: Record<string, string> = {
    live: 'text-danger',
    scheduled: 'text-textOffWhite',
    completed: 'text-subSectionText',
    cancelled: 'text-danger'
  }

  const handleClick = (sSlug: string | null | undefined) => {
    if (sSlug) {
      sSlug = sSlug?.replace('cricket/live-score', 'live-cricket-score')
      if (sStatusStr === 'live') return `/${sSlug}`
      else if (sStatusStr === 'scheduled') return `/${sSlug}`
      else if (sStatusStr === 'completed' || sStatusStr === 'cancelled') return `/${sSlug}`
      return ''
    }
    return '/'
  }

  return (
    <CustomLink
      passHref
      href={handleClick(card?.oSeo?.sSlug)}
      className="grid grid-cols-3 py-4 dark:px-0 px-4 dark:md:p-6 md:p-6 items-center md:rounded-xl dark:first:border-t  dark:last:border-b last:border-b-0 border-b md:border border-tabBorder bg-cardBg md:mb-4 last:mb-0"
    >
      {/* team A score */}
      <div>
        <div className="flex gap-2 md:gap-4 items-center justify-start">
          {card?.iBattingTeamId === card?.oTeamScoreB?.oTeam?._id && sStatusStr === 'live'
            ? TeamB
            : TeamA}
          {card?.iBattingTeamId === card?.oTeamScoreB?.oTeam?._id && sStatusStr === 'live'
            ? TeamBscore
            : TeamAscore}
        </div>
        <div className="flex md:hidden gap-4 items-center justify-start mt-0.5 md:mt-0">
          {card?.iBattingTeamId === card?.oTeamScoreB?.oTeam?._id && sStatusStr === 'live'
            ? scoreB
            : scoreA}
        </div>
      </div>

      {/* Match status */}
      <div className="text-center">
        <div
          className={`text-xxs md:text-base  font-bold ${sStatusStr === 'scheduled' ? 'line-clamp-1 md:w-full' : ''}  mb-1 ${statusColor[sStatusStr]}`}
        >
          {sStatusStr === 'scheduled' && convertDate(dateCheck(card?.dStartDate))}
          {sStatusStr === 'live' &&
            (replaceStringToShort(
              card?.oTeamScoreA?.oTeam,
              card?.oTeamScoreB?.oTeam,
              card?.sStatusNote
            ) ||
              'MatchWillStartSoon')}
          {sStatusStr === 'completed' &&
            replaceStringToShort(
              card?.oTeamScoreA?.oTeam,
              card?.oTeamScoreB?.oTeam,
              card?.sStatusNote
            )}
          {sStatusStr === 'cancelled' &&
            (replaceStringToShort(
              card?.oTeamScoreA?.oTeam,
              card?.oTeamScoreB?.oTeam,
              card?.sStatusNote
            ) ||
              'MatchAbandoned')}
        </div>

        <div className="flex items-center justify-center flex-wrap">
          {card?.oVenue?.sLocation ? (
            <>
              {/* <span className="h-1 w-1 rounded-full bg-[#353535] mx-2 block"></span> */}
              <span className="text-xxxs md:text-sm font-normal text-textDselected">
                {card?.oVenue?.sLocation}{' '}
              </span>
            </>
          ) : null}
          {card?.sSubtitle && (
            <>
              <span className="h-1 w-1 rounded-full bg-[#353535] mx-1 block"></span>
              <span className="text-xxxs md:text-sm font-normal text-textDselected ">
                {card?.sSubtitle}{' '}
              </span>
            </>
          )}
        </div>
      </div>
      <div>
        <div className="flex gap-2 md:gap-4 items-center justify-end">
          {card?.iBattingTeamId === card?.oTeamScoreB?.oTeam?._id && sStatusStr === 'live'
            ? TeamAscore
            : TeamBscore}
          {card?.iBattingTeamId === card?.oTeamScoreB?.oTeam?._id && sStatusStr === 'live'
            ? TeamA
            : TeamB}
        </div>
        <div className="flex md:hidden gap-4 items-center justify-end mt-0.5 md:mt-0">
          {card?.iBattingTeamId === card?.oTeamScoreB?.oTeam?._id && sStatusStr === 'live'
            ? scoreA
            : scoreB}
        </div>
      </div>
      {(rewriteURLs.commentary || rewriteURLs['full-scorecard']) && !hideBtns && (
        <div className="col-span-12 grid grid-cols-2 md:flex items-center gap-3 mt-4 md:mt-6">
          {rewriteURLs.commentary && (
            <CustomLink
              href={`/${rewriteURLs.commentary}`}
              className=" block text-center md:inline-block py-2 px-9 border-tabBorder border rounded-lg text-xs font-medium text-textDselected hover:bg-buttonBg hover:text-white transition-all"
            >
              Commentary
            </CustomLink>
          )}
          {rewriteURLs['full-scorecard'] && (
            <CustomLink
              href={`/${rewriteURLs['full-scorecard']}`}
              className="block text-center md:inline-block py-2 px-9 border-tabBorder border rounded-lg text-xs font-medium text-textDselected hover:bg-buttonBg hover:text-white transition-all"
            >
              Scorecard
            </CustomLink>
          )}
        </div>
      )}
    </CustomLink>
  )
}
